import { render } from "./storeManagement.vue?vue&type=template&id=9b41767c&scoped=true"
import script from "./storeManagement.vue?vue&type=script&lang=js"
export * from "./storeManagement.vue?vue&type=script&lang=js"

import "./storeManagement.vue?vue&type=style&index=0&id=9b41767c&rel=stylesheet%2Fscss&lang=scss&scoped=true"

import exportComponent from "E:\\aliPro\\platformpro\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b41767c"]])

export default __exports__